import { ShipmentMethod } from '@domain/shipment/models/ShipmentMethod';
import { TransportMethod } from '@domain/shipment/models/TransportMethod';
import { ShipmentMethodDTO } from '../dto/ShipmentDTO';

export class ShipmentMethodMapper {
  static toModel(dto: ShipmentMethodDTO): ShipmentMethod {
    return {
      id: dto.id,
      companyId: dto.companyId,
      transportMethod: dto.transportMethod as unknown as TransportMethod,
      duration: dto.duration,
      name: dto.name,
      createdAt: new Date(dto.createdAt),
      updatedAt: new Date(dto.updatedAt),
    };
  }

  static toDTO(model: ShipmentMethod): ShipmentMethodDTO {
    return {
      id: model.id,
      companyId: model.companyId,
      transportMethod: model.transportMethod as unknown as any,
      duration: model.duration,
      name: model.name,
      createdAt: model.createdAt.toISOString(),
      updatedAt: model.updatedAt.toISOString(),
    };
  }
}
